import * as yup from "yup";

/** Mirrors RecordGlobalAdminAccessInputModel.MaxReasonLength on the API. */
export const STUDIO_ACCESS_REASON_MAX_LENGTH = 300;

export const studioAccessReasonFormSchema = yup
  .object({
    reason: yup
      .string()
      .trim()
      .required("Моля, опишете защо отваряте обекта.")
      .max(
        STUDIO_ACCESS_REASON_MAX_LENGTH,
        `Причината може да е най-много ${STUDIO_ACCESS_REASON_MAX_LENGTH} символа.`,
      ),
  })
  .required();

export type IStudioAccessReasonFormModel = yup.InferType<typeof studioAccessReasonFormSchema>;

export const studioAccessReasonFormDefaultValues: IStudioAccessReasonFormModel = {
  reason: "",
};
